<template>
  <div id="settings.preferences" class="preferences">
    <article>
      <p>
        {{ translate('Appearance') }}
        <br />
        <span>
          {{ translate('Customize how Sphere looks on your device.') }}
        </span>
      </p>
      <BootstrapSelect v-model="theme" name="Theme" :options="['Light', 'Dark']" required />
    </article>
    <article>
      <p>
        {{ translate('Language') }}
        <br />
        <span>
          {{ translate('Change the language used in the user interface.') }}
        </span>
      </p>
      <BootstrapSelect
        v-model="language"
        name="Language"
        :options="['English', 'Nederlands']"
        required
      />
    </article>
  </div>
</template>
<script lang="ts" setup>
import {useLocalisation} from '@/composables/useLocalisation';
const coresStore = useCoresStore();
const userSettingsStore = useUserSettingsStore();

const theme = computed({
  get: () => (userSettingsStore.userSettings.theme === 'light-only' ? 'Light' : 'Dark'),
  set: async (value) => {
    userSettingsStore.setTheme(value === 'Light' ? 'light-only' : 'dark-only');
    await userSettingsStore.save();
  },
});

const language = computed({
  get: () => (userSettingsStore.userSettings.language === 'en-US' ? 'English' : 'Nederlands'),
  set: async (value) => {
    userSettingsStore.setLanguage(value === 'English' ? 'en-US' : 'nl-NL');
    await userSettingsStore.save();
    coresStore.switchLanguage();
  },
});

const {translate} = useLocalisation();
</script>
<style lang="scss" scoped>
.preferences {
  article {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    p {
      margin-bottom: 0;
      margin-right: 1rem;

      span {
        font-size: 0.75rem;
        color: var(--bs-secondary);
      }
    }
  }
}

:deep(.form-label) {
  display: none;
}
</style>
